module.exports = __webpack_public_path__ + "img/banner3.68c6f1f5.png";